export const namespaced = true;

export const state = {
  notifications: []
};

let nextId = 1;

export const getters = {};

export const mutations = {
  PUSH(state, notification) {
    state.notifications.push({
      ...notification,
      id: nextId++
    });
    nextId = nextId++;
  },
  DELETE(state, notificationToRemove) {
    // state.notifications = state.notifications.filter(
    //   notification => notification.id !== notificationToRemove
    // );

    for (let i = 0; i < state.notifications.length; i++) {
      if (state.notifications[i].id === notificationToRemove.id) {
        state.notifications.splice(i, 1);
      }
    }
  }
};
export const actions = {
  add({ commit }, notification) {
    commit("PUSH", notification);
  },
  remove({ commit }, notificationToRemove) {
    commit("DELETE", notificationToRemove);
  }
};
